import { render } from "./CompendiumMenu.vue?vue&type=template&id=766c6ccd"
import script from "./CompendiumMenu.vue?vue&type=script&lang=js"
export * from "./CompendiumMenu.vue?vue&type=script&lang=js"

import "./CompendiumMenu.vue?vue&type=style&index=0&id=766c6ccd&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__